module.exports = __webpack_public_path__ + "img/hc.60f5527e.png";